import React from "react";
import { Link } from "react-router-dom";
import { Divider } from "primereact/divider";
import { AddPageHeader } from "../Common/Utils";

const HonorarySpaces = () => {
  return (
    <div className="reduce-width">
      {AddPageHeader("Honorary solutions")}
      <Divider align="center">
        <h1>Honorary solutions</h1>
      </Divider>
      <div className="privacy-terms">
        The Consular Affairs Center supports the work of consular corps and
        honorary consuls around the world. Through its platforms, it fosters
        access to resources, visibility, and engagement for those involved in
        consular functions. If you would like to learn more about our
        initiatives or explore opportunities for collaboration, please feel free
        to{" "}
        <Link
          to="/contact"
          style={{
            color: "black",
            fontWeight: "bold",
          }}
        >
          contact
        </Link>{" "}
        the Center.
      </div>
    </div>
  );
};

export default HonorarySpaces;
